import React, { FC } from 'react';
import globalHooks from 'src/lib/globalHooks';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { SnackbarKey } from 'notistack';

interface PropsType {
    type: string;
    msg: string;
    duration?: number;
}

const AlertMessage: FC<PropsType> = ({ type, msg, duration }) => {
    const { enqueueSnackbar, closeSnackbar } = globalHooks.getHook('snackBar');
    enqueueSnackbar(msg ?? '', {
        anchorOrigin: { // @shivaji perpose dyanamic global alert.
            horizontal: 'right',
            vertical: 'top'
        },
        variant: type,
        preventDuplicate: true,
        // persist: true, whenever you want to close.
        action: (key: SnackbarKey) => (
        <IconButton aria-label="close" size="small" onClick={() => closeSnackbar(key)}>
            <CloseIcon fontSize="small" sx={{ color: '#fff' }} />
        </IconButton>
        ),
        autoHideDuration: duration ?? 6000
    });
    return null;
};

export default AlertMessage;
